import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { apiNoLoading,IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { SolucaoCalculadaHibrido } from "src/store/vendas/projetos/hibrido/hibrido.types";

type CalcularSolucaoInput = {
    regioes: number[];
    tensao_saida: number;
    tipo_conexao: number;
    tipo_bateria: number | null;
    taxa_descarga: number | null;
    potencia_desejada: number;
    carga_equipamentos: number;
    potencia_equipamentos: number;
    quantidade_modulos: number;
    modulo_id: number | null;
}

export class ProjetosHibridoProvider extends AProvider {
    constructor() {
        super("/projetos/hibrido");
    }

    async calcularSolucao(request: CalcularSolucaoInput): Promise<IDataResponse<SolucaoCalculadaHibrido | null>> {

        const payload: CalcularSolucaoInput = {
            ...request,
            potencia_desejada: DecimalUtil.toFixed(request.potencia_desejada, 2),
            carga_equipamentos: DecimalUtil.toFixed(request.carga_equipamentos, 2),
            potencia_equipamentos: DecimalUtil.toFixed(request.potencia_equipamentos, 2),
        }

        const response = await apiNoLoading.post({
            url: `${this.path}/dimensionamento/calcular`,
            data: payload,
        })

        if (response.statusCode !== STATUS_CODE.OK) {
            return {
                statusCode: response.statusCode,
                message: response.message || "Erro ao calcular solução.",
                data: null,
            }
        }

        return {
            ...response,
            data: {
                baterias: response.data?.baterias || [],
                inversores: response.data?.inversores || [],
            },
        }
    }
}
